<template>
    <mini-button
        name="上传附件"
        :disable="!valid"
        :loading="saveAttachmentLoading"
        @btnClick="openAttachmentModal">
        <i class="fa-solid fa-file-arrow-up"></i>

        <ReBModal v-if="valid" header="上传附件"
                  @ok="submitAttachmentChange"
                  ref="uploadAttachment">
            <multi-attachment class="w-100"
                              :query-api="finalQueryApi"
                              @loading="attachmentLoading"
                              @idsChanged="changeAttachmentIds"
                              :attachment-ids="attachmentIds"></multi-attachment>
        </ReBModal>
    </mini-button>
</template>

<script>
import MiniButton from "@/components/common/buttons/MiniButton.vue";
import MultiAttachment from "@/components/echarts-part/stuff/MultiAttachment.vue";
import ReBModal from "@/components/echarts-part/CalendarShift/cells/stuffs/ReBModal.vue";

export default {
    name: "AttachFileBtn",
    components: {ReBModal, MultiAttachment, MiniButton},
    props: {
        row: {
            type: Object,
            default: null
        },
        fieldKey: {
            type: String,
            default: 'attachments'
        },
        entityName: String,
        queryApi: String,
        uploadApi: String
    },
    data() {
        return {
            attachmentIds: '',
            saveAttachmentLoading: false,
        }
    },
    computed: {
        valid() {
            return this.row !== undefined && this.row != null;
        },
        finalQueryApi() {
            if (this.queryApi) {
                return this.queryApi;
            } else if (this.entityName) {
                return `${this.$store.state[this.entityName].baseModuleUrl}/${this.entityName}/getAttachmentList`;
            } else {
                return null;
            }
        },
        finalUploadUrl() {
            if (this.uploadApi) {
                return this.uploadApi;
            } else if (this.entityName) {
                return `${this.$store.state[this.entityName].baseModuleUrl}/${this.entityName}/upload/attachment`;
            } else {
                return null;
            }
        }
    },
    methods: {
        openAttachmentModal() {
            this.attachmentIds = this.row[this.fieldKey];
            this.$refs.uploadAttachment.showModal();
        },
        attachmentLoading(val) {
            this.$refs.uploadAttachment.changeLoading(val);
        },
        changeAttachmentIds(ids) {
            this.attachmentIds = ids;
        },
        submitAttachmentChange() {
            this.saveAttachmentLoading = true;
            this.$store.dispatch('api/put', {
                url: this.finalUploadUrl,
                entity: {
                    id: this.row.id,
                    attachments: this.attachmentIds === undefined ? "" : this.attachmentIds
                }
            }).then(() => {
                this.$message.success("保存成功");
                this.$emit('saved');
            }).finally(() => this.saveAttachmentLoading = false);
        },
    }
}
</script>

<style scoped>

</style>
